import { Stack, styled } from '@mui/material';

export const CircleBadge = styled(Stack)(({ theme }) => ({
  width: 40,
  height: 40,
  minWidth: 40,
  borderRadius: '50%',
  backgroundColor: theme.palette.common.light2,
  color: theme.palette.primary.main,
  alignItems: 'center',
  justifyContent: 'center',
}));
